<template>
  <section id="ruta" v-if="druta">
    <div class="columns is-mobile route detail">
      <div class="column is-8 has-text-left code pl-0">
        <h3 class="has-text-weight-bold is-size-1 has-text-caxton-blue">
          {{ druta.idruta }}{{ druta.manyana_tarde == 0 ? "M" : "T" }}
        </h3>
      </div>
      <div class="column is-4 is-narrow has-text-left time">
        <p class="has-text-caxton-blue is-size-4">
          {{ druta.paradas[0].horaf }} -
          {{ druta.paradas[druta.paradas.length - 1].horaf }}
        </p>

        <p
          class="has-text-caxton-blue is-size-4 mt-1"
          v-if="druta.manyana_tarde == 0"
        >
          <span class="aboard">{{ totalRuta - totalAusentesRuta }}</span
          >/<span class="total">{{ totalRuta }}</span> alumnos
        </p>
        <p
          class="has-text-caxton-blue is-size-4 mt-1"
          v-else
          v-show="total_alumnos_tarde > 0"
        >
          <span class="aboard">{{ total_bajado_tarde }}</span
          >/<span class="total">{{ total_alumnos_tarde }}</span> alumnos
        </p>
      </div>
    </div>
    <div class="columns is-mobile route detail">
      <div class="column is-8 has-text-left name pt-0 pl-0">
        <h4 class="has-text-weight-bold has-text-caxton-blue is-size-4">
          {{ druta.ruta.nombreruta }}
        </h4>
      </div>
      <div class="column is-1 has-text-left stops pt-0">
        <span
          class="circle mini stops is-size-6 has-text-weight-medium has-text-white"
          >{{
            druta.manyana_tarde == 0
              ? druta.paradas.length
              : paradasTarde.length
          }}</span
        >
      </div>
      <div class="column is-1 has-text-left passengers pt-0">
        <span
          class="circle mini passengers is-size-6 has-text-weight-medium has-text-white"
          >{{
            druta.manyana_tarde == 0 ? total_alumnos : total_alumnos_tarde
          }}</span
        >
      </div>
      <div
        class="column is-1 has-text-left passengers pt-0"
        v-show="iscached && 1 != 1"
        @click="loadFromDB"
      >
        <span
          class="circle mini has-background-primary is-size-6 has-text-weight-medium has-text-white"
        >
          <b-icon pack="fas" icon="tachometer-alt" size="is-small"> </b-icon>
        </span>
      </div>
    </div>
    <div class="columns is-mobile route annotations">
      <div class="column pl-0">
        <b-field>
          <b-select placeholder="Monitor" v-model="druta.monitor_id">
            <option
              v-for="option in this.$store.getters.maininfo.monitores"
              :key="option.id"
              :value="option.id"
              >{{ option.nombre | capitalize }}</option
            >
          </b-select>
        </b-field>
        <b-field>
          <b-select v-model="druta.conductor_id" placeholder="Conductor">
            <option
              v-for="option in this.$store.getters.maininfo.conductores"
              :key="option.id"
              :value="option.id"
              >{{ option.empleado | capitalize }}</option
            >
          </b-select>
        </b-field>
        <b-field>
          <b-select v-model="druta.bus_id" placeholder="Matrícula">
            <option
              v-for="option in this.$store.getters.maininfo.autobuses"
              :key="option.id"
              :value="option.id"
              >{{ option.matricula }}</option
            >
          </b-select>
        </b-field>
      </div>
      <div class="column is-7 is-offset-1 pr-0">
        <b-field>
          <b-input
            placeholder="Observaciones"
            maxlength="200"
            type="textarea"
            v-model="druta.observaciones"
          ></b-input>
        </b-field>
      </div>
    </div>
    <div
      class="columns is-mobile is-multiline route stops"
      v-if="this.druta.paradas.length > 0 && this.druta.manyana_tarde == 0"
    >
      <div
        class="column is-2 has-text-center"
        v-for="parada in this.druta.paradas"
        :key="parada.id"
        @click="$router.push('/parada/' + parada.orden)"
      >
        <span
          :class="{
            circle: true,
            passengers: true,
            empty: empty(parada),
            notfull: notfull(parada),
            full: !notfull(parada)
          }"
        >
          <i
            v-show="
              num_ausentes(parada) != 0 &&
                num_ausentes(parada) != num_alumnos(parada)
            "
            >{{ num_ausentes(parada) }}</i
          >
          {{ num_alumnos(parada) }}
        </span>
      </div>

      <div
        class="column is-2 has-text-center"
        v-for="(p, index) in 6 - (this.druta.paradas.length % 6) == 6
          ? 0
          : 6 - (this.druta.paradas.length % 6)"
        :key="'paradanull_' + index"
      >
        <span class="circle passengers null"></span>
      </div>
    </div>
    <!-- Modo tardes   -->
    <div
      class="columns is-mobile is-multiline route stops"
      v-if="this.druta.paradas.length > 0 && this.druta.manyana_tarde == 1"
    >
      <div
        class="column is-2 has-text-center"
        v-for="parada in paradasTarde"
        :key="parada.id"
        @click="irParadaTarde(parada.orden)"
      >
        <span
          :class="{
            circle: true,
            passengers: true,
            empty: empty(parada),
            notfull: notfull(parada),
            full: !notfull(parada)
          }"
        >
          <i v-show="num_ausentes_tarde(parada) != 0">{{
            num_ausentes_tarde(parada)
          }}</i>
          {{
            parada.orden !== 100
              ? parada.orden == 1
                ? "A"
                : num_subidos_tarde(parada)
              : "C"
          }}
        </span>
      </div>

      <div
        class="column is-2 has-text-center"
        v-for="(p, index) in 6 - (paradasTarde.length % 6) == 6
          ? 0
          : 6 - (paradasTarde.length % 6)"
        :key="'paradanull_' + index"
      >
        <span class="circle passengers null"></span>
      </div>
    </div>
    <div class="columns is-mobile is-multiline route steps">
      <div class="column is-half has-text-left">
        <b-button
          size="is-medium"
          type="is-caxton-blue"
          rounded
          icon-left="format-list-bulleted"
          @click="passengersList()"
          v-show="this.druta.manyana_tarde == 1"
        >
        </b-button>
        <b-button
          size="is-medium"
          type="is-caxton-blue"
          rounded
          icon-left="format-list-checks"
          @click="parteDiario()"
          v-show="this.druta.manyana_tarde == 1 && 1 != 1"
          class="ml-2"
        >
        </b-button>
      </div>
      <div class="column is-half has-text-right">
        <b-button
          size="is-medium"
          type="is-caxton-blue"
          rounded
          icon-left="arrow-right"
          @click="$router.push('/parada/1')"
          v-show="this.druta.manyana_tarde == 0"
        >
        </b-button>
        <b-button
          size="is-medium"
          type="is-caxton-blue"
          :class="{
            'has-background-danger': !parteCumplimentado,
            'has-background-light': parteCumplimentado
          }"
          rounded
          icon-left="format-list-checks"
          @click="parteDiario()"
          v-show="showParteDiario"
          class="ml-2"
        >
        </b-button>
        <b-button
          size="is-small"
          type="is-caxton-blue"
          rounded
          icon-left="send"
          @click="sendToServer"
          v-show="showSendToServer && parteCumplimentado"
        >
        </b-button>
      </div>
    </div>
    <b-modal
      v-model="isComponentModalActive"
      trap-focus
      full-screen
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
      animation="slide-bottom"
      custom-class="passengersList passenger"
    >
      <template #default="props">
        <Passengers @close="props.close" :detruta="druta"></Passengers>
      </template>
    </b-modal>
    <b-modal
      v-model="isParteModalActive"
      trap-focus
      full-screen
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
      animation="slide-bottom"
      custom-class="passengersList passenger"
    >
      <template #default="props">
        <ParteDiario @close="props.close" :detruta="druta"></ParteDiario>
      </template>
    </b-modal>
  </section>
</template>

<script>
import Passengers from "@/components/Passengers.vue";
import ParteDiario from "@/components/ParteDiario.vue";
export default {
  data() {
    return {
      druta: null,
      conductores: [],
      monitores: [],
      autobuses: [],
      iscached: false,
      isComponentModalActive: false,
      isParteModalActive: false
    };
  },
  name: "Ruta",
  props: ["id"],
  components: {
    Passengers,
    ParteDiario
  },

  mounted() {
    this.cargaDetalle();
    this.$store.commit("SET_NAVBACK", { text: "Rutas", url: "/rutas/" });
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value
        .toString()
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
      return value;
    }
  },
  methods: {
    cargaDetalle() {
      if (this.$store.getters.detalleruta) {
        this.druta = this.$store.getters.detalleruta;
        if (this.druta.id != this.id) {
          this.loadFromDB();
        } else {
          this.iscached = true;
        }
      } else {
        this.loadFromDB();
      }
    },
    loadFromDB() {
      this.axios.get("/api/detalleruta/" + this.id).then(response => {
        //this.rutas = response.data.rutas;
        this.druta = response.data.data;
        this.$store.commit("SET_DETALLERUTA", response.data.data);
        this.$store.commit("SET_RUTACTIVA", this.id);
        this.iscached = false;
      });
    },

    postToDB() {
      this.axios
        .post("/api/recibir-ausencias/", {
          detalleruta: this.$store.getters.detalleruta,
          usuario_id: this.$store.getters.maininfo.user.id
        })
        .then(response => {
          if (response.data == 0) {
            this.$buefy.toast.open({
              duration: 3000,
              message: "Datos enviados correctamente",
              position: "is-bottom",
              type: "is-info"
            });
            this.$router.push({ name: "Rutas" });
          } else {
            this.$buefy.toast.open({
              duration: 3000,
              message: "Esta ruta ya fue procesada. No se admiten cambios",
              position: "is-bottom",
              type: "is-danger"
            });
          }
        });
    },

    cargaParada() {},

    empty(parada) {
      return (
        this.druta.trasladados.filter(tr => tr.ordenparada == parada.orden)
          .length == 0 ||
        this.druta.trasladados.filter(tr => tr.ordenparada == parada.orden)
          .length ==
          this.druta.trasladados.filter(
            tr => tr.ordenparada == parada.orden && tr.ausente == 1
          ).length
      );
    },
    notfull(parada) {
      return (
        this.druta.trasladados.filter(tr => tr.ordenparada == parada.orden)
          .length > 0 &&
        this.druta.trasladados.filter(
          tr => tr.ordenparada == parada.orden && tr.ausente == 1
        ).length > 0
      );
    },
    num_alumnos(parada) {
      return this.druta.trasladados.filter(tr => tr.ordenparada == parada.orden)
        .length;
    },
    num_ausentes(parada) {
      return this.druta.trasladados.filter(
        tr => tr.ordenparada == parada.orden && tr.ausente == 1
      ).length;
    },
    num_ausentes_tarde(parada) {
      return this.druta.trasladados.filter(
        tr =>
          tr.ordenparada == parada.orden && (tr.ausente == 1 || tr.ausente == 4)
      ).length;
    },
    num_subidos_tarde(parada) {
      return this.druta.trasladados.filter(
        tr => tr.ordenparada == parada.orden && tr.ausente == 2
      ).length;
    },
    num_bajados_tarde(parada) {
      return this.druta.trasladados.filter(
        tr => tr.ordenparada == parada.orden && tr.ausente == 3
      ).length;
    },
    sendToServer() {
      if (
        this.druta.monitor_id !== null &&
        this.druta.bus_id !== null &&
        this.druta.conductor_id !== null
      ) {
        let message = "";
        if (this.druta.manyana_tarde == 0) {
          message =
            "Vas a confirmar las ausencias de la ruta  " +
            this.$store.getters.detalleruta.idruta +
            "<br />Se enviarán los siguientes ausentes: <br />" +
            "<div style='padding-top: 10px; padding-left: 10px;font-weight: bold;'>" +
            this.nombreAusentesRuta +
            "</div><br /> <br /><strong>¿estás seguro?</strong>";
        } else {
          message =
            "Vas a confirmar las ausencias de la ruta  " +
            this.$store.getters.detalleruta.idruta +
            ", <br /><strong>¿estás seguro?</strong>";
        }

        this.$buefy.dialog.confirm({
          title: "CONFIRMAMOS ENVÍO",
          message: message,
          onConfirm: () => {
            console.log("Send To Server");
            this.postToDB();
          },
          type: "is-info"
        });
      } else {
        this.$buefy.dialog.alert({
          message: "Debes cumplimentar: Monitor, Conductor y Matricula",
          title: "Alerta!!",
          type: "is-danger"
        });
      }
    },
    passengersList() {
      //Carga en un modal el componente del listado de alumnos (rutas tardes)
      this.isComponentModalActive = true;
      return true;
    },
    parteDiario() {
      this.isParteModalActive = true;
      return true;
    },

    irParadaTarde(parada) {
      this.$router.push("/parada-cole-tarde/" + parada);
    }
  },
  computed: {
    total_alumnos() {
      return this.druta.trasladados.length;
    },
    total_ausentes() {
      return this.druta.trasladados.filter(tr => tr.ausente == 1).length;
    },
    totalParada() {
      return this.druta
        ? this.druta.trasladados.filter(tr => tr.ordenparada == this.orden)
            .length
        : 0;
    },
    totalAusentes() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.ordenparada == this.orden && tr.ausente != 0
          ).length
        : 0;
    },
    totalAusentesRuta() {
      return this.druta
        ? this.druta.trasladados.filter(tr => tr.ausente == 1).length
        : 0;
    },
    totalAusentesRutaTarde() {
      return this.druta
        ? this.druta.trasladados.filter(
            tr => tr.ausente == 1 || tr.ausente == 4
          ).length
        : 0;
    },
    totalRuta() {
      return this.druta ? this.druta.trasladados.length : 0;
    },
    paradasTarde() {
      let tmp = this.druta.paradas.slice(1, -1);
      return tmp;
    },
    showParteDiario() {
      if (this.druta.manyana_tarde == 1) {
        return this.druta
          ? this.druta.trasladados.filter(
              tr => tr.fecha_control_bajada && tr.fecha_control_bajada !== null
            ).length > 0
            ? true
            : false
          : false;
      } else {
        return this.druta
          ? this.druta.trasladados.filter(
              tr =>
                tr.fecha_control_ausencia && tr.fecha_control_ausencia !== null
            ).length > 0
            ? true
            : false
          : false;
      }
    },
    showSendToServer() {
      return true;
    },
    total_alumnos_tarde() {
      return this.druta.trasladados.filter(
        tr => tr.ordenparada < 100 && tr.ausente == 2
      ).length;
    },
    total_bajado_tarde() {
      return this.druta.trasladados.filter(
        tr => tr.ordenparada < 100 && tr.ausente == 3
      ).length;
    },
    nombreAusentesRuta() {
      return this.druta
        ? this.druta.trasladados
            .filter(tr => tr.ausente == 1)
            .map(v => v.nombrecompleto)
            .join("<br />")
        : null;
    },
    parteCumplimentado() {
      return typeof this.druta.parte.find(q => q.value == null) == "undefined"
        ? true
        : false;
    }
  },
  beforeDestroy() {
    this.$store.commit("SET_DETALLERUTA", this.druta);
    console.log("Sale de Parada !!!");
  }
};
</script>
